module.exports = __webpack_public_path__ + "img/con_4.f84841f3.svg";